var isFunction = function isFunction(functionToCheck) {
  return !!(typeof functionToCheck === 'function' && !!functionToCheck.constructor && !!functionToCheck.call && !!functionToCheck.apply);
};
export default isFunction;